import script from "./CDNUploadPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CDNUploadPage.vue?vue&type=script&setup=true&lang=ts"

import "./CDNUploadPage.vue?vue&type=style&index=0&id=1a7213bb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a7213bb"]])

export default __exports__